// extracted by mini-css-extract-plugin
export default {"smart-banner-spacer":"styles__smart-banner-spacer--Yt7u2","smart-banner-fix":"styles__smart-banner-fix--atJgS"};